import { render, staticRenderFns } from "./BlockType21.vue?vue&type=template&id=3c3dbe0a"
import script from "./BlockType21.vue?vue&type=script&lang=ts"
export * from "./BlockType21.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports